import Vue from 'vue';

// local state
const getDefaultState = () => {
  return {
    values: {},
  }
};

const state = getDefaultState()

const getters = {
  // Need { buildingHeatProtection: Building.heatProtection, unitOccupancy: Units[x].occupancy }
  getTable4Constant: (state) => (payload) => {
    if (!state.values) return null;
    if (payload.buildingHeatProtection == 1 && payload.unitOccupancy == 0) return state.values.table4.gB_wsH;
    if (payload.buildingHeatProtection == 0 && payload.unitOccupancy == 0) return state.values.table4.gB_wsN;
    if (payload.buildingHeatProtection == 1 && payload.unitOccupancy == 1) return state.values.table4.hB_wsH;
    if (payload.buildingHeatProtection == 0 && payload.unitOccupancy == 1) return state.values.table4.hB_wsN;
  },

  // Need { buildingLocation: Building.location, unitMultiStorey: Units[x].multiStorey }
  getTable5Constant: (state) => (payload) => {
    if (!state.values) return null;
    if (payload.buildingLocation == 1 && payload.unitMultiStorey == 0) return state.values.table5.multiStorey_highWind;
    if (payload.buildingLocation == 0 && payload.unitMultiStorey == 0) return state.values.table5.multiStorey_lowWind;
    if (payload.buildingLocation == 1 && payload.unitMultiStorey == 1) return state.values.table5.singleStorey_highWind;
    if (payload.buildingLocation == 0 && payload.unitMultiStorey == 1) return state.values.table5.singleStorey_lowWind;
  },

  // Need { buildingHeatProtection: Building.heatProtection, unitOccupancy: Units[x].occupancy }
  getTable6Constant: (state) => (payload) => {
    if (!state.values) return null;
    if (payload.buildingHeatProtection == 1 && payload.unitOccupancy == 0) return state.values.table6.fs_gB_wsH
    if (payload.buildingHeatProtection == 0 && payload.unitOccupancy == 0) return state.values.table6.fs_gB_wsN
    if (payload.buildingHeatProtection == 1 && payload.unitOccupancy == 1) return state.values.table6.fs_hB_wsH
    if (payload.buildingHeatProtection == 0 && payload.unitOccupancy == 1) return state.values.table6.fs_hB_wsN
  },

  getFlstnl: (state) => {
    return state.values.table6.nl
  },

  getFlstil: (state) => {
    return state.values.table6.il
  },

  getFlstrl: (state) => {
    return state.values.table6.rl
  },

  // Need { unitLtm: Units[x].ventilationMeasure, unitFireplace: Units[x].fireplace }
  getTable9Constant: (state) => (payload) => {
    // check if unit fireplace is null or nan then set it to 0
    if (payload.unitFireplace == null || isNaN(payload.unitFireplace)) payload.unitFireplace = 0
    if (payload.unitLtm == 2 && payload.unitFireplace == 1) return state.values.table9.vglAb_mFs
    else if (payload.unitLtm == 2 && (payload.unitFireplace == 0 || payload.unitFireplace == null)) return state.values.table9.vglAb_oFs
    else if ((payload.unitLtm == 1 || payload.unitLtm == 7) && payload.unitFireplace == 1) return state.values.table9['18017_mFs']
    else if ((payload.unitLtm == 1 || payload.unitLtm == 7) && (payload.unitFireplace == 0 || payload.unitFireplace == null)) return state.values.table9['18017_oFs']
  },

  // N50 Need { buildingAirtightness: Building.airtightness, buildingAirExchange: Building.airExchange }
  getTable10Constant: (state) => (payload) => {
    if (!state.values) return null;
    if (payload.buildingAirtightness == 0) return state.values.table10.fan_assisted;
    else if (payload.buildingAirtightness == 1) return state.values.table10.free_after2002;
    else if (payload.buildingAirtightness == 2 && (payload.buildingAirExchange == null || payload.buildingAirExchange <= 0)) return state.values.table10.free_befor2002;
    else return payload.buildingAirExchange;
  },


};

const mutations = {
  updateValue(state, values) {
    state.values = values
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
};

const actions = {
  resetState({commit}) {
    commit('resetState')
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
